import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Apropos from "./components/Apropos";
import Boutique from "./components/Boutique";
import Restaurant from "./components/Restaurant";
import Chalet from "./components/Chalet";
import Musee from "./components/Musee";
import Huillerie from "./components/Huillerie";
import Academie from "./components/Academie";
import ProduitDetails from "./components/ProduitDetails";
import Contact from "./components/Contact";
import EventDetails from "./components/EventDetails";

const DefaultLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DefaultLayout><Home /></DefaultLayout>} />
        <Route path="/Apropos" element={<DefaultLayout><Apropos /></DefaultLayout>} />
        <Route path="/boutique" element={<DefaultLayout><Boutique /></DefaultLayout>} />
        <Route path="/contact" element={<DefaultLayout><Contact /></DefaultLayout>} />
        <Route path="/restaurant" element={<DefaultLayout><Restaurant /></DefaultLayout>} />
        <Route path="/chalet" element={<DefaultLayout><Chalet /></DefaultLayout>} />
        <Route path="/musee" element={<DefaultLayout><Musee /></DefaultLayout>} />
        <Route path="/huillerie" element={<DefaultLayout><Huillerie /></DefaultLayout>} />
        <Route path="/academie" element={<DefaultLayout><Academie /></DefaultLayout>} />
        <Route path="/produitDetails/:id" element={<DefaultLayout><ProduitDetails /></DefaultLayout>} />
        <Route path="/event/:id" element={<DefaultLayout><EventDetails /></DefaultLayout>} />
      </Routes>
    </Router>
  );
};

export default App;
